import React from 'react';
import { MapContainer, TileLayer, CircleMarker, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
interface Area {
  name: string;
  lat: number;
  lng: number;
}
const AREAS: Area[] = [{
  name: 'Gilbert',
  lat: 33.3528,
  lng: -111.789
}, {
  name: 'Queen Creek',
  lat: 33.2487,
  lng: -111.6343
}, {
  name: 'San Tan Valley',
  lat: 33.1862,
  lng: -111.5497
}, {
  name: 'Chandler',
  lat: 33.3062,
  lng: -111.8413
}, {
  name: 'Mesa',
  lat: 33.4152,
  lng: -111.8315
}, {
  name: 'Apache Junction',
  lat: 33.4151,
  lng: -111.5496
}, {
  name: 'Tempe',
  lat: 33.4255,
  lng: -111.94
}, {
  name: 'Scottsdale',
  lat: 33.4942,
  lng: -111.9261
}];
export function ServiceAreaMap() {
  return <MapContainer center={[33.36, -111.78]} zoom={10} scrollWheelZoom={false} style={{
    height: '100%',
    width: '100%'
  }} className="z-0" data-id="element-195">
      <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" data-id="element-196" />
      {AREAS.map(area => <CircleMarker key={area.name} center={[area.lat, area.lng]} radius={9} pathOptions={{
      color: '#F9F7EA',
      weight: 2,
      fillColor: '#D56A32',
      fillOpacity: 0.9
    }} data-id="element-197">
          <Tooltip direction="top" offset={[0, -6]} opacity={1} data-id="element-198">
            <span className="font-semibold text-[#3F1610]" data-id="element-199">{area.name}</span>
          </Tooltip>
        </CircleMarker>)}
    </MapContainer>;
}